module.exports = __webpack_public_path__ + "img/logo_televet_branca.01f480e6.png";